import MethodologiesCausesForm from 'src/javascripts/components/forms/MethodologiesCausesForm';

export default class SettingsAccountsMethodologiesCausesEdit {

  constructor() {}

  render() {

  	MethodologiesCausesForm();

  }

}